module.exports = __webpack_public_path__ + "img/IMG_4215_L.0e5f40e2.webp";